module.exports = __webpack_public_path__ + "img/tree_animals_group (1).299837d3.png";